import { render, staticRenderFns } from "./ticketOrganizationDetail.vue?vue&type=template&id=e31729ce&scoped=true"
import script from "./ticketOrganizationDetail.vue?vue&type=script&lang=js"
export * from "./ticketOrganizationDetail.vue?vue&type=script&lang=js"
import style0 from "./ticketOrganizationDetail.vue?vue&type=style&index=0&id=e31729ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31729ce",
  null
  
)

export default component.exports